"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._modifyAdjustmentSilo = exports._exportAdjustmentActualHauling = exports._getGridUploadHistorySilo = exports._submitCorrection = exports._uploadSilo = exports._uploadSiloManualTicket = exports._downloadTemplateSilo = exports._deleteReason = exports._getAdjustmentSiloHopperDeleted = exports._getAdjustmentSiloHopper = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const qs_1 = __importDefault(require("qs"));
const _getAdjustmentSiloHopper = ({ skip, take, filter, sort }, start_date, end_date) => __awaiter(void 0, void 0, void 0, function* () {
    const filterFilter = filter
        ? {
            logic: filter.logic,
            filters: filter.filters
                .map((item) => item.field === 'is_duplicate' ? null : item)
                .filter((item) => item !== null)
        }
        : { logic: 'and', filters: [] };
    const filterString = filterFilter.filters.length > 0 ? JSON.stringify(filterFilter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/SiloHopper';
    const params = {
        skip: skip,
        take: take,
        sort: sortString,
        filter: filterString,
        end_date: end_date,
        start_date: start_date,
    };
    const is_duplicated = filter === null || filter === void 0 ? void 0 : filter.filters.find((item) => item.field === 'is_duplicate');
    if (is_duplicated) {
        params.is_duplicated = is_duplicated.value === 'Duplicated' ? true : false;
    }
    const config = {
        params: params,
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], dataSiloTon: [], dataSiloTrip: [], countData: 0 };
    }
});
exports._getAdjustmentSiloHopper = _getAdjustmentSiloHopper;
const _getAdjustmentSiloHopperDeleted = ({ skip, take, filter, sort }, start_date, end_date) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/SiloHopperDeleted';
    const config = {
        params: {
            skip,
            take,
            sort: sortString,
            end_date: end_date,
            filter: filterString,
            start_date: start_date,
        },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], dataSiloTon: [], dataSiloTrip: [], countData: 0 };
    }
});
exports._getAdjustmentSiloHopperDeleted = _getAdjustmentSiloHopperDeleted;
const _deleteReason = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/adjustment/SiloHopper/${arg.id}`;
    try {
        const { data } = yield axios_1.default.put(url, arg, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._deleteReason = _deleteReason;
const _downloadTemplateSilo = (type) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/download-template';
    const config = {
        params: { type: type },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, url: '' };
    }
});
exports._downloadTemplateSilo = _downloadTemplateSilo;
const _uploadSiloManualTicket = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/SiloHopper-upload';
    const newPayload = {
        filename: payload.filename,
        filename_approval: payload.filename_approval,
        justification: payload.justification
    };
    const data = qs_1.default.stringify(newPayload);
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: {
            type: payload.type
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, message: '', countData: 0 };
    }
});
exports._uploadSiloManualTicket = _uploadSiloManualTicket;
const _uploadSilo = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/upload-file';
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.post(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._uploadSilo = _uploadSilo;
const _submitCorrection = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/transaction/silo';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.put(url, data, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, name: '', countData: 0 };
    }
});
exports._submitCorrection = _submitCorrection;
const _getGridUploadHistorySilo = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/SiloHopper-log';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getGridUploadHistorySilo = _getGridUploadHistorySilo;
const _exportAdjustmentActualHauling = ({ skip, take, filter, sort }, start_date, end_date) => __awaiter(void 0, void 0, void 0, function* () {
    const filterFilter = filter
        ? {
            logic: filter.logic,
            filters: filter.filters
                .map((item) => item.field === 'is_duplicate' ? null : item)
                .filter((item) => item !== null)
        }
        : { logic: 'and', filters: [] };
    const filterString = filterFilter.filters.length > 0 ? JSON.stringify(filterFilter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/adjustment/SiloHopper/getDownloadDataAdjustment';
    const params = {
        sort: sortString,
        end_date,
        filter: filterString,
        start_date,
        skip,
        take
    };
    const is_duplicated = filter === null || filter === void 0 ? void 0 : filter.filters.find((item) => item.field === 'is_duplicate');
    if (is_duplicated) {
        params.is_duplicated = is_duplicated.value === 'Duplicated' ? true : false;
    }
    const config = {
        params: params,
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, content: '', name: '', type: '', data: {} };
    }
});
exports._exportAdjustmentActualHauling = _exportAdjustmentActualHauling;
const _modifyAdjustmentSilo = (data) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/adjustment/transaction/silo';
        const response = yield axios_1.default.post(url, data, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
            }
        });
        return response.data;
    }
    catch (e) {
        return (0, error_response_1.errorResponse)(e);
    }
});
exports._modifyAdjustmentSilo = _modifyAdjustmentSilo;
